import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import * as yup from "yup";
import { TabView, TabPanel } from "primereact/tabview";
import { Editor } from "primereact/editor";
import { DialogActions, Typography } from "@material-ui/core";
import {
  FormSelectField,
  FormTextField,
} from "../../../../../partials/content/Forms/FormField";
import { Card } from "react-bootstrap";
import { onPreventEnterSubmitting } from "../../../../../utils/utils";
import {
  getItemsToBeDeliveredFromDeliveryOrder,
  getItemsToBeDeliveredFromOperation,
  getItemsToBeDeliveredFromSalesPos,
  getItemsToBeDeliveredFromSalesReturn,
  saveDelivery,
} from "../../../../../services/inventory/deliveryService";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import SearchWarehouse from "../../../inventory/warehouses/searchWarehouse";
import Swal from "sweetalert2";
import { PickList } from "primereact/picklist";
import DeliveryService from "./deliveryService";
import SearchSalesPos from "../../../sales/pos/searchSalesPos";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
import { DateTime } from "luxon";
import Illustration from "../../../../../partials/content/Illustration";
import SearchSalesReturn from "../../../sales/sales-return/SearchSalesReturn";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import { getCountriesOptionValues } from "../../../../../services/commons";
import MapPlaces from "../../../../../partials/content/MapPlaces";
import SearchDeliveriesReserveComplete from "../../../sales/delivery-order/SearchDeliveriesReserveComplete";
function DeliveryForm({
  deliveryOrderID = 0,
  operationCardID = 0,
  warehouseID = 0,
  warehouseName = "",
  outletID = 0,
  onCloseDialog,
  onSubmitDelivery,
}) {
  const [openSearchDocRef, setOpenSearchDocRef] = useState(false);
  const [openSearchWarehouse, setOpenSearchWarehouse] = useState(false);
  const [itemsReadyToDeliver, setItemsReadyToDeliver] = useState([]);
  const [openSearchMapPlaces, setOpenSearchMapPlaces] = useState(false);
  const { companyProfile } = useGlobalData();
  const [countries, setCountries] = useState([]);
  const [delivery, setDelivery] = useState({
    ID: 0,
    docRef: "DO",
    docRefDesc: "",
    invoiceID: 0,
    customerID: 0,
    customerName: "",
    salesOrderID: 0,
    salesReturnID: 0,
    salesOrderCode: "",
    operationCardID,
    salesPosID: 0,
    warehouseID,
    warehouseName: "",
    resiNo: "",
    deliveryDate: DateTime.now().startOf("day"),
    currencyID: companyProfile.currency.ID,
    currencyCode: companyProfile.currency.currencyCode,
    deliveryCost: 0,
    driverName: "",
    recipient: "",
    address: "",
    city: "",
    province: "",
    postalCode: "",
    addressPhone: "",
    addressEmail: "",
    countryCode: companyProfile.countryCode,
    countryName: "",
    note: "",
    fiscalYear: 0,
    fiscalPeriod: 0,
    deliveryItem: [],
    deliveryService: [],
    CreatedAt: DateTime.now(),
    UpdatedAt: DateTime.now(),
    createdBy: 0,
    updatedBy: 0,
  });

  const deliveryFormSchema = yup.object().shape({
    ID: yup.number(),
    salesOrderID: yup.number(),
    customerID: yup.number(),
    customerName: yup.string().when("customerID", {
      is: (value) => value > 0,
      then: yup.string().required("Customer is required"),
    }),
    resiNo: yup.string(),
    deliveryDate: yup.date().required(),
    currencyID: yup.number(),
    currencyCode: yup.string(),
    deliveryCost: yup.string(),
    driverName: yup
      .string()
      .max(255, "Delivery Team Name maximum characters is 255"),
    recipient: yup
      .string()
      .required("Ship To is required")
      .max(255, "Ship To maximum characters is 255"),
    address: yup
      .string()
      .required("Address is required")
      .max(255, "Address maximum characters is 255"),
    city: yup
      .string()
      .required("City is required")
      .max(50, "City maximum characters is 50"),
    addressPhone: yup
      .string()
      .required("Phone Number is required")
      .matches(
        /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/,
        "Phone Number must be valid. e.g. +6281XXXXXXX or 081XXXXXXX"
      )
      .max(50, "Phone Number maximum characters is 50"),
    addressEmail: yup
      .string()
      .email("Email must be valid. e.g. joe@invifo.com")
      .max(50, "Email maximum characters is 50"),
    province: yup.string().max(50, "Province maximum characters is 50"),
    countryCode: yup.string(),
    postalCode: yup.string().max(10, "Postal Code maximum characters is 10"),
    deliveryItem: yup
      .array()
      .of(
        yup.object().shape({
          ID: yup.number(),
          itemID: yup.number(),
          itemName: yup.string(),
          varCode: yup.string(),
          batchID: yup.number(),
          uomID: yup.number(),
          uomName: yup.string(),
          send: yup.bool(),
        })
      )
      .nullable(),
    deliveryService: yup
      .array()
      .of(
        yup.object().shape({
          ID: yup.number(),
          qty: yup
            .number()
            .max(
              yup.ref("qtyOrder"),
              "Delivered Quantity cannot be more than Ordered Quantity"
            ),
          qtyOrder: yup.number(),
        })
      )
      .nullable(),
  });
  useEffect(() => {
    if (operationCardID > 0) {
      getItemsToBeDeliveredFromOperationData(operationCardID);
    } else if (deliveryOrderID > 0) {
      getItemsToBeDeliveredFromDeliveryOrderData(
        deliveryOrderID,
        warehouseID,
        warehouseName
      );
    } else {
      handleGetCountriesOptionValues();
    }
  }, [deliveryOrderID, warehouseID, warehouseName]);
  return (
    <Formik
      initialValues={delivery}
      enableReinitialize={true}
      validateOnChange={false}
      validationSchema={deliveryFormSchema}
      onSubmit={(values, { resetForm, setStatus, setSubmitting }) => {
        values.warehouseID = parseInt(values.warehouseID);
        values.deliveryCost = parseFloat(values.deliveryCost);
        let itemSendFound = false;
        for (const delItem of values.deliveryItem) {
          if (delItem.send) {
            itemSendFound = true;
            break;
          }
        }

        for (const service of values.deliveryService) {
          service.qty = parseFloat(service.qty);
          if (service.qty > 0) {
            itemSendFound = true;
          }
        }
        if (itemSendFound) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          })
            .fire({
              title: "Are you sure want to save this Delivery ?",
              text: "Please note that you are responsible for this action",
              icon: "question",
              showCloseButton: true,
              showCancelButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
              cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
              reverseButtons: true,
            })
            .then((result) => {
              if (result.isConfirmed) {
                saveDelivery(values).then((response) => {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  }).fire({
                    title: "Saved",
                    html: response.data.message,
                    icon: "success",
                    showCloseButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                  });
                  onSubmitDelivery();
                });
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Cancelled",
                  text: "No change has been made",
                  icon: "info",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
              }
            });
        } else {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Failed",
            text:
              "Please select the items or fill service quantity which need to be delivered",
            icon: "error",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      }}
    >
      {({
        values,
        status,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isSubmitting,
      }) => (
        <form
          noValidate={true}
          autoComplete="off"
          className="kt-form"
          onSubmit={handleSubmit}
          onKeyDown={onPreventEnterSubmitting}
        >
          <div className="tabview">
            <div className="card">
              <TabView className="tabview" scrollable>
                <TabPanel
                  header="Goods Issued Main"
                  rightIcon="fas fa-th-large"
                >
                  <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <Card>
                        <Card.Header>
                          <i className="fas fa-window-maximize"></i>
                          <span>
                            <strong>Goods Issued Header</strong>
                          </span>
                        </Card.Header>
                        <Card.Body>
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-12">
                              {outletID === 0 ? (
                                <>
                                  {warehouseID === 0 ? (
                                    <FormTextField
                                      label="Warehouse Name"
                                      name="warehouseName"
                                      searchButton
                                      readonly
                                      onSearchClick={() => {
                                        setOpenSearchWarehouse(true);
                                      }}
                                    />
                                  ) : null}
                                </>
                              ) : null}
                              {deliveryOrderID === 0 ? (
                                <React.Fragment>
                                  <div className="row">
                                    <div className="col-sm-6 col-md-6 col-lg-6">
                                      <FormTextField
                                        label="Document Reference"
                                        name="docRefDesc"
                                        searchButton
                                        readonly
                                        onSearchClick={() => {
                                          setOpenSearchDocRef(true);
                                        }}
                                      />
                                    </div>
                                    <div className="col-sm-6 col-md-6 col-lg-6">
                                      {values.docRef === "DO" ? (
                                        <FormTextField
                                          label="Delivery Order ID"
                                          name="deliveryOrderCode"
                                          readonly
                                        />
                                      ) : values.docRef === "POS" ? (
                                        <FormTextField
                                          label="Sales POS ID"
                                          name="salesPosID"
                                          readonly
                                        />
                                      ) : values.docRef === "SLR" ? (
                                        <FormTextField
                                          label="Sales Return ID"
                                          name="salesReturnID"
                                          readonly
                                        />
                                      ) : null}
                                    </div>
                                  </div>
                                </React.Fragment>
                              ) : null}
                              <FormTextField
                                label="Customer Name"
                                name="customerName"
                                readonly
                              />
                              <FormTextField
                                label="Delivery Receipt No"
                                name="resiNo"
                              />
                              <FormTextField
                                label="Delivery Team"
                                name="driverName"
                              />
                              {/*
                                <div className="row">
                                  <div className="col-sm-6 col-md-6 col-lg-6">
                                    <FormTextField
                                      label="Currency"
                                      name="currencyCode"
                                      readonly
                                    />
                                  </div>
                                  <div className="col-sm-6 col-md-6 col-lg-6">
                                    <FormTextField
                                      label="Delivery Cost"
                                      name="deliveryCost"
                                      currencyField
                                      currencyCode={values.currencyCode}
                                    />
                                  </div>
                                </div>
                                */}
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <Card>
                        <Card.Header>
                          <i className="fas fa-map-marked-alt"></i>
                          <span>
                            <strong>Shipping Address</strong>
                          </span>
                        </Card.Header>
                        <Card.Body>
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-12">
                              <FormTextField label="Ship To" name="recipient" />
                              <div className="row">
                                <div className="col-sm-6 col-md-6 col-lg-6">
                                  <FormTextField
                                    label="Address"
                                    name="address"
                                    mapsButton
                                    onMapsClick={() => {
                                      setOpenSearchMapPlaces(true);
                                    }}
                                  />
                                  <FormTextField label="City" name="city" />
                                  <FormTextField
                                    label="Province / State"
                                    name="province"
                                  />
                                </div>
                                <div className="col-sm-6 col-md-6 col-lg-6">
                                  <FormTextField
                                    label="Phone Number"
                                    name="addressPhone"
                                  />
                                  <FormTextField
                                    label="Email"
                                    name="addressEmail"
                                  />
                                  <FormTextField
                                    label="Postal Code"
                                    name="postalCode"
                                  />
                                </div>
                              </div>
                              <FormSelectField
                                label="Country"
                                name="countryCode"
                                options={countries}
                              />
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </div>
                  </div>
                </TabPanel>
                {((values.deliveryOrderID > 0 || values.salesReturnID > 0) &&
                  itemsReadyToDeliver &&
                  itemsReadyToDeliver.length > 0) ||
                ((values.deliveryOrderID > 0 || values.salesReturnID > 0) &&
                  values.deliveryItem &&
                  values.deliveryItem.length > 0) ? (
                  <TabPanel header="Delivery Item" rightIcon="fas fa-stream">
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <div className="card">
                          {(itemsReadyToDeliver &&
                            itemsReadyToDeliver.length > 0) ||
                          (values.deliveryItem &&
                            values.deliveryItem.length > 0) ? (
                            <div className="py-3">
                              <PickList
                                source={itemsReadyToDeliver}
                                target={values.deliveryItem}
                                itemTemplate={itemTemplate}
                                sourceHeader="Items Ready to Deliver"
                                targetHeader="Delivery Item"
                                sourceStyle={{ height: "342px" }}
                                targetStyle={{ height: "342px" }}
                                onChange={(event) => {
                                  setItemsReadyToDeliver(event.source);
                                  setFieldValue("deliveryItem", event.target);
                                }}
                              />
                            </div>
                          ) : (
                            <div className="py-3">
                              <Illustration
                                imageSource="INVIFO Sales.png"
                                description={`No available Item which ready to be delivered yet!`}
                                guidance="Hint: once the sales order items has been prepared and reserved, it will be displayed here"
                                descriptionLeftIcon="fas fa-info-circle kt-font-warning"
                                size="md"
                              ></Illustration>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                ) : (
                  <TabPanel
                    header="Delivery Item"
                    rightIcon="fas fa-stream"
                    disabled
                  ></TabPanel>
                )}
                {outletID === 0 &&
                values.deliveryOrderID > 0 &&
                values.deliveryService &&
                values.deliveryService.length > 0 ? (
                  <TabPanel header="Delivery Service" rightIcon="fas fa-stream">
                    <DeliveryService />
                  </TabPanel>
                ) : (
                  <TabPanel
                    header="Delivery Service"
                    rightIcon="fas fa-stream"
                    disabled
                  ></TabPanel>
                )}
                <TabPanel header={"Note"} rightIcon="fas fa-sticky-note">
                  <Editor
                    style={{ height: "200px", width: "100%" }}
                    onTextChange={(e) => {
                      setFieldValue("note", e.htmlValue);
                    }}
                    value={values.note}
                    placeholder="Type your notes here..."
                  />
                </TabPanel>
              </TabView>
            </div>
            <DialogLayout
              open={openSearchWarehouse}
              title="Search Warehouse"
              onCloseDialog={() => {
                setOpenSearchWarehouse(false);
              }}
              maxWIdth="md"
            >
              <SearchWarehouse
                onSelectWarehouse={(warehouse) => {
                  getItemsToBeDeliveredFromDeliveryOrderData(
                    deliveryOrderID,
                    warehouse.ID,
                    warehouse.warehouseName
                  );
                  setOpenSearchWarehouse(false);
                }}
              />
              <DialogActions>
                <button
                  type="button"
                  className="btn btn-label-danger btn-md btn-pill btn-bold"
                  onClick={() => {
                    setOpenSearchWarehouse(false);
                  }}
                >
                  <i className="fas fa-window-close"></i>
                  Close
                </button>
              </DialogActions>
            </DialogLayout>
            <DialogLayout
              open={openSearchDocRef}
              title="Search Document Reference"
              onCloseDialog={() => {
                setOpenSearchDocRef(false);
              }}
              minHeight={true}
            >
              <div className="tabview">
                <div className="card">
                  <TabView>
                    <TabPanel header="Delivery Order" rightIcon="fas fa-truck">
                      {warehouseID > 0 ? (
                        <SearchDeliveriesReserveComplete
                          warehouseID={warehouseID}
                          onSelectDeliveryOrder={(deliveryOrder) => {
                            getItemsToBeDeliveredFromDeliveryOrderData(
                              deliveryOrder.ID,
                              warehouseID,
                              warehouseName
                            );
                            setOpenSearchDocRef(false);
                          }}
                        />
                      ) : null}
                    </TabPanel>
                    <TabPanel
                      header="Point of Sales"
                      rightIcon="fas fa-cash-register"
                    >
                      <SearchSalesPos
                        outletID={outletID}
                        showAmount={true}
                        onSelectSalesPos={(salesPos) => {
                          getItemsToBeDeliveredFromSalesPosData(salesPos);
                          setOpenSearchDocRef(false);
                        }}
                      />
                    </TabPanel>
                    <TabPanel
                      header="Sales Return"
                      rightIcon="fas fa-truck-loading"
                    >
                      <SearchSalesReturn
                        warehouseID={warehouseID}
                        giStatus={12}
                        onSelectSalesReturn={(salesReturn) => {
                          handleGetItemsToBeDeliveredFromSalesReturn(
                            salesReturn
                          );
                          setOpenSearchDocRef(false);
                        }}
                      />
                    </TabPanel>
                  </TabView>
                </div>
              </div>
              <DialogActions>
                <button
                  type="button"
                  className="btn btn-label-danger btn-md btn-pill btn-bold"
                  onClick={() => {
                    setOpenSearchDocRef(false);
                  }}
                >
                  <i className="fas fa-window-close"></i>
                  Close
                </button>
              </DialogActions>
            </DialogLayout>
            <DialogLayout
              open={openSearchMapPlaces}
              title="Search Address on Maps"
              onCloseDialog={() => {
                setOpenSearchMapPlaces(false);
              }}
              maxWIdth="lg"
              minHeight={true}
            >
              <MapPlaces
                address={values.address}
                city={values.city}
                province={values.province}
                countryCode={values.countryCode}
                postalCode={values.postalCode}
                onPinLocation={(
                  selectedFormattedAddress,
                  selectedShortAddressComponents,
                  selectedLongAddressComponents,
                  selectedAddress,
                  selectedCity,
                  selectedProvince,
                  selectedCountryCode,
                  selectedPostalCode
                ) => {
                  setFieldValue(`address`, selectedAddress);
                  setFieldValue(`city`, selectedCity);
                  setFieldValue(`province`, selectedProvince);
                  setFieldValue(`countryCode`, selectedCountryCode);
                  setFieldValue(`postalCode`, selectedPostalCode);
                  setOpenSearchMapPlaces(false);
                }}
                onCloseDialog={() => {
                  setOpenSearchMapPlaces(false);
                }}
              />
            </DialogLayout>
          </div>
          <DialogActions>
            <button
              type="button"
              className="btn btn-label-danger btn-md btn-pill btn-bold"
              onClick={onCloseDialog}
            >
              <i className="fas fa-window-close"></i>
              Close
            </button>
            <button
              onClick={handleSubmit}
              type="submit"
              className="btn btn-success btn-md btn-pill btn-bold"
            >
              <i className="fas fa-save"></i>
              Save
            </button>
          </DialogActions>
        </form>
      )}
    </Formik>
  );

  async function handleGetItemsToBeDeliveredFromSalesReturn(salesReturn) {
    let itemsReadyToDeliverData = [];
    const response = await getItemsToBeDeliveredFromSalesReturn(
      salesReturn.ID,
      warehouseID
    );
    const { data } = response.data;
    const { itemsReservation } = data;
    for (const itemReserve of itemsReservation) {
      itemsReadyToDeliverData.push({
        ID: 0,
        itemsReservationID: itemReserve.ID,
        salesReturnID: itemReserve.salesReturnID,
        salesReturnItemID: itemReserve.salesReturnItemID,
        operationStockID: 0,
        itemID: itemReserve.itemID,
        itemType: itemReserve.itemType,
        itemTypeName: itemReserve.itemTypeName,
        itemCode: itemReserve.itemCode,
        itemName: itemReserve.itemName,
        varCode: itemReserve.varCode,
        batchID: itemReserve.batchID,
        qty: itemReserve.qty,
        uomID: itemReserve.uomID,
        uomName: itemReserve.uom.uomName,
        send: true,
      });
    }
    setItemsReadyToDeliver(itemsReadyToDeliverData);
    setDelivery({
      ID: 0,
      docRef: "SLR",
      docRefDesc: "Sales Return",
      invoiceID: 0,
      salesReturnID: salesReturn.ID,
      salesOrderID: 0,
      salesOrderCode: "",
      operationCardID,
      customerID: salesReturn.customerID,
      customerName: salesReturn.customer.customerName,
      outletID: 0,
      resiNo: "",
      deliveryDate: DateTime.now().startOf("day"),
      currencyID: 0,
      currencyCode: "",
      deliveryCost: 0,
      driverName: "",
      recipient: salesReturn.customer.customerName,
      address: salesReturn.salesOrder.soDeliveryAddress.address,
      city: salesReturn.salesOrder.soDeliveryAddress.city,
      province: salesReturn.salesOrder.soDeliveryAddress.province,
      postalCode: salesReturn.salesOrder.soDeliveryAddress.postalCode,
      addressPhone: salesReturn.salesOrder.soDeliveryAddress.addressPhone,
      addressEmail: salesReturn.salesOrder.soDeliveryAddress.addressEmail,
      countryCode: salesReturn.salesOrder.soDeliveryAddress.countryCode,
      note: "",
      deliveryItem: [],
      deliveryService: [],
    });
  }

  async function getItemsToBeDeliveredFromSalesPosData(salesPos) {
    let itemsReadyToDeliverData = [];
    const response = await getItemsToBeDeliveredFromSalesPos(
      salesPos.ID,
      warehouseID,
      outletID
    );
    const { data } = response.data;
    const { itemsReservation } = data;
    for (const itemReserve of itemsReservation) {
      itemsReadyToDeliverData.push({
        ID: 0,
        itemsReservationID: itemReserve.ID,
        salesOrderID: itemReserve.salesOrderID,
        salesOrderItemID: itemReserve.salesOrderItemID,
        salesPosID: itemReserve.salesPosID,
        salesPosItemID: itemReserve.salesPosItemID,
        operationStockID: 0,
        itemID: itemReserve.itemID,
        itemType: itemReserve.itemType,
        itemTypeName: itemReserve.itemTypeName,
        itemCode: itemReserve.itemCode,
        itemName: itemReserve.itemName,
        varCode: itemReserve.varCode,
        batchID: itemReserve.batchID,
        qty: itemReserve.qty,
        uomID: itemReserve.uomID,
        uomName: itemReserve.uom.uomName,
        send: true,
      });
    }
    setItemsReadyToDeliver(itemsReadyToDeliverData);
    setDelivery({
      ID: 0,
      docRef: "POS",
      docRefDesc: "Point of Sales",
      invoiceID: 0,
      salesPosID: salesPos.ID,
      salesOrderID: 0,
      salesOrderCode: "",
      operationCardID,
      customerID: salesPos.customerID,
      customerName: salesPos.customer.customerName,
      outletID: salesPos.outletID,
      resiNo: "",
      deliveryDate: DateTime.now().startOf("day"),
      currencyID: 0,
      currencyCode: "",
      deliveryCost: 0,
      driverName: "",
      recipient: salesPos.recipient,
      address: salesPos.address,
      city: salesPos.city,
      province: salesPos.province,
      postalCode: salesPos.postalCode,
      addressPhone: salesPos.addressPhone,
      addressEmail: salesPos.addressEmail,
      note: "",
      deliveryItem: [],
      deliveryService: [],
    });
  }

  async function handleGetCountriesOptionValues() {
    const response = await getCountriesOptionValues();
    const { data } = response.data;
    setCountries(data.countries);
  }

  async function getItemsToBeDeliveredFromDeliveryOrderData(
    deliveryOrderID,
    warehouseID,
    warehouseName
  ) {
    const response = await getItemsToBeDeliveredFromDeliveryOrder(
      deliveryOrderID,
      warehouseID
    );
    const { data } = response.data;
    const { deliveryOrder, itemsReservation, serviceItems, countries } = data;
    setCountries(countries);
    let itemsReadyToDeliverData = [];
    let serviceItemsData = [];

    for (const itemReserve of itemsReservation) {
      itemsReadyToDeliverData.push({
        ID: 0,
        itemsReservationID: itemReserve.ID,
        salesOrderID: itemReserve.salesOrderID,
        salesOrderItemID: itemReserve.salesOrderItemID,
        deliveryOrderID: itemReserve.deliveryOrderID,
        deliveryOrderItemID: itemReserve.deliveryOrderItemID,
        salesPosID: itemReserve.salesPosID,
        salesPosItemID: itemReserve.salesPosItemID,
        operationStockID: 0,
        itemID: itemReserve.itemID,
        itemType: itemReserve.itemType,
        itemTypeName: itemReserve.itemTypeName,
        itemCode: itemReserve.itemCode,
        itemName: itemReserve.itemName,
        varCode: itemReserve.varCode,
        batchID: itemReserve.batchID,
        qty: itemReserve.qty,
        uomID: itemReserve.uomID,
        uomName: itemReserve.uom.uomName,
        send: true,
      });
    }

    for (const service of serviceItems) {
      serviceItemsData.push({
        timeSheetID: 0,
        deliveryID: 0,
        salesOrderID: service.salesOrderID,
        salesOrderItemID: service.ID,
        salesPosID: 0,
        salesPosItemID: 0,
        timeSheetDate: 0,
        itemID: service.itemID,
        itemType: service.itemType,
        itemTypeName: service.itemTypeName,
        serviceCode: service.itemCode,
        serviceName: service.itemName,
        varCode: service.varCode,
        qty: 0,
        qtyOrder: service.qty,
        uomID: service.uomID,
        uomName: service.uomName,
      });
    }
    setItemsReadyToDeliver(itemsReadyToDeliverData);

    setDelivery({
      ID: 0,
      docRef: "DO",
      docRefDesc: "Delivery Order",
      invoiceID: 0,
      deliveryOrderID: deliveryOrder.ID,
      deliveryOrderCode: deliveryOrder.deliveryOrderCode,
      salesOrderID: deliveryOrder.salesOrderID,
      operationCardID,
      salesPosID: 0,
      customerID: deliveryOrder.customerID,
      customerName: deliveryOrder.customer.customerName,
      warehouseID,
      warehouseName,
      resiNo: "",
      deliveryDate: DateTime.now().startOf("day"),
      //currencyID: deliveryOrder.currencyID,
      //currencyCode: deliveryOrder.currency.currencyCode,
      //deliveryCost: 0,
      driverName: "",
      recipient: deliveryOrder.customer.customerName,
      address: deliveryOrder.address,
      city: deliveryOrder.city,
      province: deliveryOrder.province,
      postalCode: deliveryOrder.postalCode,
      addressPhone: deliveryOrder.addressPhone,
      addressEmail: deliveryOrder.addressEmail,
      countryCode: deliveryOrder.countryCode,
      countryName: deliveryOrder.countryName,
      note: "",
      deliveryItem: [],
      deliveryService: serviceItemsData,
    });
  }

  async function getItemsToBeDeliveredFromOperationData(operationCardID) {
    const response = await getItemsToBeDeliveredFromOperation(operationCardID);
    const { data } = response.data;
    const { operationCard, operationStock, serviceItems, countries } = data;
    setCountries(countries);
    let itemsReadyToDeliverData = [];
    let serviceItemsData = [];
    for (const stock of operationStock) {
      itemsReadyToDeliverData.push({
        ID: 0,
        salesOrderID: operationCard.salesOrderID,
        salesOrderItemID: stock.salesOrderItemID,
        operationStockID: stock.ID,
        itemID: stock.itemID,
        itemType: stock.itemType,
        itemTypeName: stock.itemTypeName,
        itemCode: stock.itemCode,
        itemName: stock.itemName,
        varCode: stock.varCode,
        batchID: stock.batchID,
        qty: stock.qty,
        uomID: stock.uomID,
        uomName: stock.uomName,
        send: true,
      });
    }
    for (const service of serviceItems) {
      serviceItemsData.push({
        timeSheetID: 0,
        deliveryID: 0,
        salesOrderID: service.salesOrderID,
        salesOrderItemID: service.ID,
        salesPosID: 0,
        salesPosItemID: 0,
        timeSheetDate: 0,
        itemID: service.itemID,
        itemType: service.itemType,
        itemTypeName: service.itemTypeName,
        serviceCode: service.itemCode,
        serviceName: service.itemName,
        varCode: service.varCode,
        qty: 0,
        qtyOrder: service.qty,
        uomID: service.uomID,
        uomName: service.uomName,
      });
    }
    setItemsReadyToDeliver(itemsReadyToDeliverData);
    setDelivery({
      ID: 0,
      invoiceID: 0,
      salesOrderID: operationCard.salesOrderID,
      operationCardID,
      salesPosID: 0,
      customerID: operationCard.customerID,
      customerName: operationCard.customer.customerName,
      warehouseID,
      warehouseName,
      resiNo: "",
      deliveryDate: DateTime.now().startOf("day"),
      //currencyID: operationCard.salesOrder.currencyID,
      //currencyCode: operationCard.salesOrder.currency.currencyCode,
      //deliveryCost: 0,
      driverName: "",
      recipient: "",
      address: operationCard.salesOrder.soDeliveryAddress.address,
      city: operationCard.salesOrder.soDeliveryAddress.city,
      province: operationCard.salesOrder.soDeliveryAddress.province,
      postalCode: operationCard.salesOrder.soDeliveryAddress.postalCode,
      addressPhone: operationCard.salesOrder.soDeliveryAddress.addressPhone,
      addressEmail: operationCard.salesOrder.soDeliveryAddress.addressEmail,
      countryCode: operationCard.salesOrder.soDeliveryAddress.countryCode,
      countryName: operationCard.salesOrder.soDeliveryAddress.countryName,
      note: "",
      deliveryItem: [],
      deliveryService: serviceItemsData,
    });
  }
}

const itemTemplate = (item) => {
  return (
    <table>
      <tr>
        <td>
          <Typography variant="body2" className="mx-1 my-1 kt-font-bolder">
            Item Name
          </Typography>
        </td>
      </tr>
      <tr>
        <td>
          <Typography className="mx-1 my-1">
            {item.itemType > 0 ? (
              <span>
                <BootstrapTooltip title={item.itemTypeName}>
                  <span className="mr-2">
                    <i
                      className={
                        item.itemType === 1
                          ? "fas fa-boxes text-success"
                          : item.itemType === 2
                          ? "fas fa-tools text-primary"
                          : item.itemType === 3
                          ? "fas fa-building text-info"
                          : item.itemType === 4
                          ? "fas fa-boxes text-warning"
                          : item.itemType === 5
                          ? "fas fa-boxes text-danger"
                          : null
                      }
                    ></i>
                  </span>
                </BootstrapTooltip>
                <span>
                  {item.itemCode} {item.itemName}
                </span>
              </span>
            ) : (
              <React.Fragment>
                {item.itemCode} {item.itemName}
              </React.Fragment>
            )}
          </Typography>
        </td>
      </tr>
      <tr>
        <td>
          <Typography variant="body2" className="mx-1 my-1 kt-font-bolder">
            Delivered Quantity
          </Typography>
        </td>
      </tr>
      <tr>
        <td>
          <Typography className="mx-1 my-1">
            {item.qty} {item.uomName}
          </Typography>
        </td>
      </tr>
      <tr>
        <td>
          <Typography variant="body2" className="mx-1 my-1 kt-font-bolder">
            Batch ID
          </Typography>
        </td>
      </tr>
      <tr>
        <td>
          <Typography className="mx-1 my-1">{item.batchID}</Typography>
        </td>
      </tr>
    </table>
  );
};

export default DeliveryForm;
